import { Pipe, PipeTransform, inject } from '@angular/core'
import { DecimalPipe } from '@angular/common'

@Pipe({
    name: 'numberOrNaN',
    standalone: false
})
export class NumberOrNaNPipe implements PipeTransform {
  private decimalPipe = inject(DecimalPipe)
  transform (value: number | string, naNValue?: number | string, digitsInfo?: string, locale?: string): string | null
  transform (value: null | undefined, naNValue?: number | string, digitsInfo?: string, locale?: string): null
  transform (value: number | string | null | undefined, naNValue: number | string = '-', digitsInfo?: string, locale?: string): string | null {
    return typeof value === 'number' && isNaN(value)
      ? naNValue as string
      : this.decimalPipe.transform(value, digitsInfo, locale)
  }
}